import React, { useEffect, useRef, useState } from 'react'
import { ReactComponent as FillDetails } from '../../../../../../assets/images/fillDetails.svg'
import { Button, Input } from '../../../../../../components/common'
import { ReactComponent as ArrowRight } from "../../../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeftWhite } from "../../../../../../assets/icons/arrowleftwhite.svg";
import { ReactComponent as ArrowLeft } from "../../../../../../assets/icons/arrowleft.svg";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetDocumentToFillDataMutation, useUploadFinanceDocumentMutation, useUploadFinanceDocumentsDataMutation, useUploadFinanceDocumentsMutation } from '../../../../../../store/Company/companyApiSlice';
import { useSelector } from 'react-redux';
import { CommonToast } from '../../../../../common/Toast';
import CommonTooltip from '../../../../../common/Tooltip';
import { ReactComponent as Warning } from "../../../../../../assets/icons/Warning.svg";
import { ValueSetter } from 'date-fns/parse/_lib/Setter';
import { ReactComponent as Info } from "../../../../../../assets/icons/info.svg";
import { ReactComponent as Error } from "../../../../../../assets/icons/error.svg";
import { isDateGreaterThanProvidedYearsAgo } from "../../../../../../utils/Helper";
import { ReactComponent as MoreInfo } from "../../../../../../assets/moreInfo.svg";
import { ReactComponent as ReUploadIcon } from "../../../../../../assets/images/companyIcons/ReUploadIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../../assets/images/companyIcons/delete.svg";
import pdf1 from "../../../../../../assets/images/pdf.svg";
import { uploadFileToS3 } from "../../../../../../utils/uploadFileToS3";
import { uploadFilePath } from "../../../../../../constants/s3UploadPath";

function FillCopanyData({ onPrev, onNext, onSkip }) {
  const navigate = useNavigate()
  const location = useLocation();
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token, userInfo } = useSelector((state) => state.auth);
  const [getDocumentToFillData, { isLoading: documentLoading }] = useGetDocumentToFillDataMutation()
  const [uploadFinanceDocuments, { isLoading: uploadingData }] = useUploadFinanceDocumentsMutation();
  const [uploadFinanceDocumentsData, { isLoading: documentSubmitting }] = useUploadFinanceDocumentsDataMutation()
  const [uploadFinanceDocument, { isLoading: valueUploading }] = useUploadFinanceDocumentMutation();

  const yearRef = useRef();
  const revenueRef = useRef();
  const earningRef = useRef();
  const goodsRef = useRef();
  const expensesRef = useRef();
  const equityRef = useRef();
  const assetsRef = useRef();
  const currentRef = useRef();
  const inventoriesRef = useRef();
  const liabilitiesRef = useRef();
  const receivablesRef = useRef();
  const payablesRef = useRef();
  const shortRef = useRef();
  const longRef = useRef();
  const portionRef = useRef();
  const flowRef = useRef();
  const operationRef = useRef();
  const interestRef = useRef();
  const fileInputRef = useRef([]);
  const [optionDisplay, setOptionDisplay] = useState(Array(5).fill(false));
  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(Array(6).fill(null));
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [imageArray, setImageArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [selectedYear, setSelectedYear] = useState();
  const [userUploadedData, setUserUploadedData] = useState([])
  const [selectedData, setSelectedData] = useState()
  const [dataPayload, setDataPayload] = useState([]);
  const currentYear = new Date().getFullYear();
  const [currentIndex, setCurrentindex] = useState(-1);
  const [years, setYears] = useState([]);
  const yearsArray = Array.from({ length: 6 }, (_, index) => {
    return currentYear - index;
  });
  const [hideLastYear, setHideLastYear] = useState(true);

  const getDocumentDetails = async () => {
    const response = await getDocumentToFillData({
      companyId: currentEditingCompany?.companyID,
      token,
    });
    const createdImageArray = []
    for (const data of response?.data?.data) {
      const year = parseInt(data.yearID.split('-')[0]); // Extract the year from yearID
      const index = yearsArray.indexOf(year); // Find the index of the year in years array
      if (index !== -1) {
        previewUrl[index] = data.document;
        createdImageArray.push({ year: year, document: data?.document })
      }
    }
    if (imageArray.length === 0) {
      setImageArray(createdImageArray)
    }
    setUserUploadedData(response?.data?.data);
  }

  useEffect(() => {
    setCurrentindex(years?.indexOf(selectedYear));
  }, [selectedYear])

  function processFinancialData(data) {
    // Extract years using map
    let years = yearsArray;
    // Remove duplicate years using Set and spread operator
    setYears(years);
    const maxYear = years[0];
    if (!selectedYear) {
      setSelectedYear(maxYear);
    }
    // Filter the data for the selected year using filter
    const selectUploadedData = data?.filter(entry => +(entry.yearID.split('-')[0]) === selectedYear ?? maxYear);
    setSelectedData(selectUploadedData?.length > 0 && selectUploadedData[0]);

  }
  useEffect(() => {
    if (userUploadedData?.length === 0) {
      getDocumentDetails();
    }
  }, [])
  useEffect(() => {
    processFinancialData(userUploadedData)
  }, [userUploadedData, selectedYear, setSelectedYear])

  useEffect(() => {
    const filteredObjects = dataPayload.filter(obj => +obj.year === selectedYear);
    const isValuePresent = filteredObjects?.length > 0;
    yearRef.current.value = selectedYear;
    revenueRef.current.value = isValuePresent ? filteredObjects[0].total_revenue ?? "" : selectedData?.existing?.total_revenue ?? "";
    earningRef.current.value = isValuePresent ? filteredObjects[0].net_earnings ?? "" : selectedData?.existing?.net_earnings ?? "";
    goodsRef.current.value = isValuePresent ? filteredObjects[0].cost_of_goods_serv_sold ?? "" : selectedData?.existing?.cost_of_goods_serv_sold ?? "";
    expensesRef.current.value = isValuePresent ? filteredObjects[0].interest_expenses ?? "" : selectedData?.existing?.interest_expenses ?? "";
    equityRef.current.value = isValuePresent ? filteredObjects[0].total_equity ?? "" : selectedData?.existing?.total_equity ?? "";
    assetsRef.current.value = isValuePresent ? filteredObjects[0].total_assets ?? "" : selectedData?.existing?.total_assets ?? "";
    currentRef.current.value = isValuePresent ? filteredObjects[0].total_current_assets ?? "" : selectedData?.existing?.total_current_assets ?? "";
    inventoriesRef.current.value = isValuePresent ? filteredObjects[0].inventories ?? "" : selectedData?.existing?.inventories ?? "";
    liabilitiesRef.current.value = isValuePresent ? filteredObjects[0].total_current_liabilities ?? "" : selectedData?.existing?.total_current_liabilities ?? "";
    receivablesRef.current.value = isValuePresent ? filteredObjects[0].trade_receivables ?? "" : selectedData?.existing?.trade_receivables ?? "";
    payablesRef.current.value = isValuePresent ? filteredObjects[0].trade_payables ?? "" : selectedData?.existing?.trade_payables ?? "";
    shortRef.current.value = isValuePresent ? filteredObjects[0].short_term_debt ?? "" : selectedData?.existing?.short_term_debt ?? "";
    longRef.current.value = isValuePresent ? filteredObjects[0].long_term_debt ?? "" : selectedData?.existing?.long_term_debt ?? "";
    portionRef.current.value = isValuePresent ? filteredObjects[0].current_long_term_debt_portion ?? "" : selectedData?.existing?.current_long_term_debt_portion ?? "";
    flowRef.current.value = isValuePresent ? filteredObjects[0].net_cash_flow_investment ?? "" : selectedData?.existing?.net_cash_flow_investment ?? "";
    operationRef.current.value = isValuePresent ? filteredObjects[0].net_cash_flow_operations ?? "" : selectedData?.existing?.net_cash_flow_operations ?? "";
    interestRef.current.value = isValuePresent ? filteredObjects[0].earnings_before_interest_tax ?? "" : selectedData?.existing?.earnings_before_interest_tax ?? "";
  }, [selectedData, selectedYear])
  const YearItem = ({ year }) => {
    return (
      ((hideLastYear && year === years[years.length - 1]) || (!hideLastYear && year === years[0])) ? null : <div className={`pointer before:border-l-[20px] cursor-default ${selectedYear === year ? "bg-[#004469] before:border-l-[#004469] text-white" : "bg-[#96B2C2] before:border-l-[#96B2C2] text-[#004469]"}`}>Year {year}</div>
    );
  };

  const handleSubmit = async () => {
    try {
      await handleNavigation(false);
    } catch (error) {
      CommonToast.error("Error while uploading")
    }
  }

  useEffect(() => {
    if (!hideLastYear) {
      const filteredData = dataPayload.filter(obj => +obj.year !== currentYear);
      setDataPayload(filteredData)
    }
  }, [hideLastYear])

  function hasKeysOtherThanYear(obj) {
    for (let key in obj) {
      if (key !== 'year') {
        return true; // There is a key other than 'year'
      }
    }
    return false; // There are no keys other than 'year'
  }

  const handleUplaodFinancialDocument = async (data) => {
    try {
      const response = await uploadFinanceDocument({
        data: data,
        company_id: currentEditingCompany?.companyID,
        token,
      });
      const uploadResponse = await uploadFinanceDocuments({
        data: imageArray,
        token: token,
        companyId: currentEditingCompany?.companyID,
        location: 'fill'
      });
      if (response?.data?.statusCode === 201 && uploadResponse?.data?.statusCode === 200) {
        CommonToast.success(response?.data?.message)
        if (hideLastYear && selectedYear === years[years.length - 2] || !hideLastYear && selectedYear === years[years.length - 1]) {
          onNext(0, "MOA", "Upload KK")
        } else {
          setSelectedYear(selectedYear - 1)
        }
      }
    } catch (error) {

    }
  }

  const valueEmptyCheck = (str) => {
    return str !== "" ? str : null;
  }

  const handleNavigation = async (next = true) => {
    const payloadData = {
      year: yearRef.current.value,
      total_revenue: valueEmptyCheck(revenueRef.current.value),
      net_earnings: valueEmptyCheck(earningRef.current.value),
      cost_of_goods_serv_sold: valueEmptyCheck(goodsRef.current.value),
      earnings_before_interest_tax: valueEmptyCheck(interestRef.current.value),
      interest_expenses: valueEmptyCheck(expensesRef.current.value),
      total_equity: valueEmptyCheck(equityRef.current.value),
      total_assets: valueEmptyCheck(assetsRef.current.value),
      total_current_assets: valueEmptyCheck(currentRef.current.value),
      inventories: valueEmptyCheck(inventoriesRef.current.value),
      total_current_liabilities: valueEmptyCheck(liabilitiesRef.current.value),
      trade_receivables: valueEmptyCheck(receivablesRef.current.value),
      trade_payables: valueEmptyCheck(payablesRef.current.value),
      long_term_debt: valueEmptyCheck(longRef.current.value),
      short_term_debt: valueEmptyCheck(shortRef.current.value),
      current_long_term_debt_portion: valueEmptyCheck(portionRef.current.value),
      net_cash_flow_operations: valueEmptyCheck(operationRef.current.value),
      net_cash_flow_investment: valueEmptyCheck(interestRef.current.value)
    };
    const cleanPayloadData = Object.fromEntries(
      Object.entries(payloadData).filter(([key, value]) => value !== '')
    );

    const indexToUpdate = dataPayload?.findIndex(item => item.year === cleanPayloadData.year);
    const checkForKeys = hasKeysOtherThanYear(cleanPayloadData);
    if (checkForKeys) {
      dataPayload[indexToUpdate] = payloadData;
      if (indexToUpdate !== -1) {
        // If an object with the same year exists, replace it with the current values
        if (!next) {
          handleUplaodFinancialDocument(dataPayload)
          // return dataPayload
        }
      } else {
        // If no object with the same year exists, add the new object to the array
        const update = [...dataPayload, payloadData]
        setDataPayload(update);
        if (!next) {
          handleUplaodFinancialDocument(update);
          // return update
        }
      }

      next && setSelectedYear(selectedYear - 1);
      document.getElementById('view')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      CommonToast.error('Form cannot be empty');
    }
  }

  function get_url_extension(url) {
    if (url !== undefined) {
      return url.split(/[#?]/)[0].split(".").pop().trim();
    }
  }
  const handleFileChange = async (e) => {
    setIsDataLoading(true);
    const file = e.target.files[0];
    const nameValue = e.target.parentElement.previousElementSibling.innerText;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const updatedPreviewUrls = [...previewUrl];
        if (file.type == "application/pdf") {
          updatedPreviewUrls[currentIndex] = pdf1;
        } else {
          updatedPreviewUrls[currentIndex] = reader.result;
        }
        setPreviewUrl(updatedPreviewUrls);
      };
      reader.readAsDataURL(file);
    }

    const response = await uploadFileToS3(uploadFilePath?.auditedFinancial, file, token, currentEditingCompany?.companyID, "financial_document");
    const existingIndex = imageArray.findIndex((img) => img.year === selectedYear);

    // If the year exists, update the document URL; otherwise, add a new entry
    if (existingIndex !== -1) {
      const updatedImageArray = [...imageArray];
      updatedImageArray[existingIndex] = { year: selectedYear, document: response?.url };
      setImageArray(updatedImageArray);

    } else {
      setImageArray([...imageArray, { year: selectedYear, document: response?.url }]);
    }
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[currentIndex] = !updatedOptionDisplay[currentIndex];
      setIsDataLoading(false);
      return updatedOptionDisplay;
    });
    setIsDataLoading(false);
  };

  const handleChooseFile = async (index) => {
    const file = fileInputRef.current[currentIndex].click();
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[currentIndex] = !updatedOptionDisplay[currentIndex];
      return updatedOptionDisplay;
    });
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setIsDragging(index);
  };

  const handleDragLeave = (e, index) => {
    setIsDragging(false);
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[currentIndex] = !updatedOptionDisplay[currentIndex];
      return updatedOptionDisplay;
    });
  };

  const handleDrop = async (e, index) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];

    const nameValue = e.target.parentElement.previousElementSibling.innerText;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const updatedPreviewUrls = [...previewUrl];
        updatedPreviewUrls[currentIndex] = reader.result;
        setPreviewUrl(updatedPreviewUrls);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleOption = (option) => {
    if (option === "reupload") {
      fileInputRef.current[currentIndex].click();
    } else if (!isDataLoading) {
      setOptionDisplay((prevState) => {
        const updatedOptionDisplay = [...prevState];
        updatedOptionDisplay[currentIndex] = !updatedOptionDisplay[currentIndex];
        return updatedOptionDisplay;
      });
    }
  };
  const viewDoc = (doclink) => {
    window.open(doclink, "_blank");
  };
  return (
    <div className='max-w-[1280px] m-auto'>
      {/* <div className='w-full flex justify-between items-end mb-3'>
        <h3 className='text-[36px] font-[700] leading-[43.2px]'>Company Financials Details</h3>
        <FillDetails />
      </div> */}
      <h5 className='text-left'>Enter Information Manually</h5>
      <div id={'view'} className='flex flex-col gap-6 py-3 sm:flex-col md:flex-row'>
        {years.map((year) => (
          <YearItem key={year} year={year} />
        ))}
      </div>
      <div className='mb-4'>
        <div className='flex justify-between items-end mb-4'>
          <h4 className='text-left text-[18px] font-[600] tracking-[5%]'>Income Statement</h4>
        </div>
        <div className='flex flex-col gap-3 border rounded-[8px] p-4'>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input disable={true} inputRef={yearRef} label={"Year"} />
            <Input inputRef={revenueRef} label={"Total Revenue"} />
          </div>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={earningRef} label={"Net Earning"} />
            <Input inputRef={goodsRef} label={"Cost of goods Service Sold"} />
          </div>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={interestRef} label={"Earning Before Interest Tax"} />
            <Input inputRef={expensesRef} label={"Interest Expenses"} />
          </div>
        </div>
      </div>
      <div className='mb-4'>
        <h4 className='text-left text-[18px] font-[600] tracking-[5%] mb-4'>Balance Sheet</h4>
        <div className='flex flex-col gap-3 border rounded-[8px] p-4'>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={equityRef} label={"Total Equity"} />
            <Input inputRef={assetsRef} label={"Total Assets"} />
          </div>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={currentRef} label={"Total Current Assets"} />
            <Input inputRef={inventoriesRef} label={"Inventories"} />
          </div>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={liabilitiesRef} label={"Total Current Liabilities"} />
            <Input inputRef={receivablesRef} label={"Trade Receivables"} />
          </div>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={payablesRef} label={"Trade Payables"} />
            <Input inputRef={shortRef} label={"Short Term Debt"} />
          </div>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={longRef} label={"Long Term Debt"} />
            <Input inputRef={portionRef} label={"Current Long Term Debt Portion"} />
          </div>
        </div>
      </div>
      <div className='mb-4'>
        <h4 className='text-left text-[18px] font-[600] tracking-[5%] mb-4'>Cash flow statement</h4>
        <div className='flex flex-col gap-3 border rounded-[8px] p-4'>
          <div className='flex gap-5 sm:flex-wrap md:flex-nowrap' >
            <Input inputRef={flowRef} label={"Net Cash Flow Investment"} />
            <Input inputRef={operationRef} label={"Net Cash Flow Operation"} />
          </div>
        </div>
      </div>
      <div>
        {isDataLoading ?
          <div className="w-full flex justify-center items-center flex-col"><Spinner /><p>Uploading</p></div> :
          <div className=" w-full text-left mb-5">
            <div className="text-primary font-semibold mb-2 text-[12px] md:text-[18px] sm:text-[13px]">
              {/* {item.name} */}
              Upload File (Optional)
            </div>
            <div
              className={`border-2 ${previewUrl[currentIndex] ? "border" : "border-dashed"
                }  rounded-lg relative h-48 p-8 ${false ? "border-rose-600 bg-rose-100" : "border-input"} ${isDragging ? "bg-gray-100" : ""
                }`}
              onDragOver={(e) => handleDragOver(e)}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e)}
            >
              <input
                type="file"
                accept=".jpg, .jpeg, .png, .pdf"
                onChange={(e) => handleFileChange(e)}
                ref={(el) => (fileInputRef.current[currentIndex] = el)}
                className="hidden"
              />
              {previewUrl[currentIndex] != undefined && previewUrl[currentIndex] ? (
                isDataLoading ? <div className="flex justify-center items-center flex-col"><Spinner /><p>Uploading</p></div> : <div className="w-full h-36 overflow-hidden border-input rounded-lg border-2 bg-uploadImg">
                  {get_url_extension(previewUrl[currentIndex]) == "pdf" ? (
                    <img
                      src={pdf1}
                      alt="Preview PDF"
                      height="40px"
                      className="mx-auto w-3/5"
                      onClick={() => {
                        viewDoc(previewUrl[currentIndex]);
                      }}
                    />
                  ) : (
                    <img
                      src={previewUrl[currentIndex]}
                      onClick={() => {
                        viewDoc(previewUrl[currentIndex]);
                      }}
                      alt="Preview IMG"
                      height="40px"
                      className="mx-auto w-3/5"
                    />
                  )}
                </div>
              ) : (
                <div className="text-center">
                  <div>
                    <svg
                      className="w-12 h-12 mx-auto mb-4 text-gray-500"
                      width="49"
                      height="38"
                      viewBox="0 0 49 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => handleChooseFile()}
                    >
                      <path
                        d="M40.4927 12.6436C38.2742 3.80599 29.3117 -1.55986 20.4741 0.65858C13.5677 2.3923 8.55291 8.36136 8.03622 15.4632C3.13241 16.2719 -0.187381 20.9027 0.621312 25.8065C1.3402 30.1661 5.11773 33.3588 9.53605 33.3412H17.0352V30.3416H9.53605C6.22273 30.3416 3.53671 27.6555 3.53671 24.3422C3.53671 21.0289 6.22273 18.3429 9.53605 18.3429C10.3644 18.3429 11.0359 17.6714 11.0359 16.843C11.0284 9.388 17.0659 3.33841 24.5209 3.33101C30.9743 3.32454 36.5296 7.88685 37.778 14.2183C37.8381 14.5266 37.9934 14.8083 38.2222 15.0236C38.4509 15.2388 38.7414 15.3769 39.0528 15.4182C43.1532 16.0021 46.0037 19.7994 45.4199 23.8997C44.8956 27.5816 41.752 30.323 38.0329 30.3416H32.0336V33.3412H38.0329C43.8313 33.3237 48.5175 28.609 48.4999 22.8106C48.4853 17.9839 45.1815 13.789 40.4927 12.6436Z"
                        fill="#5B8098"
                      />
                      <path
                        d="M23.4696 18.778L17.4702 24.7773L19.585 26.8921L23.0346 23.4575V37.8409H26.0343V23.4575L29.4689 26.8921L31.5837 24.7773L25.5843 18.778C24.9993 18.1964 24.0546 18.1964 23.4696 18.778Z"
                        fill="#5B8098"
                      />
                    </svg>
                    <p className="md:text-[16px] sm:text-[11px] text-[10px] text-secondarytwo">
                      {isDragging ? "Drop the file here" : "Drag & drop or "}
                      <button
                        type="button"
                        onClick={() => handleChooseFile()}
                        className="text-primaryText font-semibold focus:outline-none"
                      >
                        Choose file
                      </button>
                      to upload
                      <span className="md:text-[14px] text-secondary block text-[10px] sm:text-[10px]">
                        Supported format : JPG, JPEG, PNG, PDF
                      </span>
                    </p>
                  </div>
                </div>
              )}
              {previewUrl[currentIndex] && (
                <div className="bg-white absolute w-full border-input rounded-b-lg px-8 py-2 border-t-2 bottom-0 left-0 h-16 flex justify-between items-center">
                  <div>
                    <div className="text-secondarytwo sm:text-[10px] md:text-[14px] text-[8px]">
                      {/* {item.update} */}
                      Year {selectedYear}
                    </div>
                    <div className="text-secondary tracking-wider sm:text-[10px] md:text-[14px] text-[10px] ">
                    </div>
                  </div>
                  <div className="justify-end items-center flex flex-row-reverse ">
                    <MoreInfo
                      className={`cursor-pointer mr-0 ml-auto `}
                      onClick={() => handleOption("more-info")}
                    />

                    {optionDisplay[currentIndex] && !isDataLoading && (
                      <ul className="border-2 border-input rounded-lg mt-36 bg-white p-3 w-full z-10">
                        <li
                          className="py-1 flex items-center gap-2.5 text-f16 text-secondarytwo cursor-pointer"
                          onClick={() => {
                            handleOption("reupload");
                          }}
                        >
                          {" "}
                          <div>
                            <ReUploadIcon />
                          </div>
                          Re - Upload Document
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>}
      </div>
      <div className='flex justify-between px-4'>
        <Button
          classes="gobackBtn inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold"
          onClick={() => onPrev()}
        >
          <ArrowLeft />
          <span className="relative">Go Back</span>
        </Button>
        <div className='flex gap-2'>
          <CommonTooltip id={"warn-tooltip"} classes={years[0] !== selectedYear && 'hidden'} content={`If the year ${selectedYear} is skipped, any corresponding additional data will be deleted.`}>
            <Button
              classes={`relative group py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 ${disable ? "bg-disable cursor-not-allowed" : "bg-primary cursor-pointer"}`}
              onClick={() => { setSelectedYear(years[0] !== selectedYear ? selectedYear + 1 : selectedYear === years[1] && !hideLastYear ? selectedYear + 1 : selectedYear - 1); years[0] === selectedYear && setHideLastYear(false); years[1] === selectedYear && setHideLastYear(true); document.getElementById('view')?.scrollIntoView({ behavior: 'smooth' }) }}
            >
              {years[0] !== selectedYear && <ArrowLeftWhite />}
              <span className="relative">
                {isLoading ? <Spinner /> : years[0] !== selectedYear ? "Previous" : "Skip"}
              </span>
            </Button>
          </CommonTooltip>
          <Button
            classes={`relative group py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 ${disable ? "bg-disable cursor-not-allowed" : "bg-primary cursor-pointer"}`}
            onClick={years[0] - (!hideLastYear ? 3 : 2) >= selectedYear ? handleSubmit : handleNavigation}
          >
            <span className="relative">
              {isLoading ? <Spinner /> : years[0] - (!hideLastYear ? 3 : 2) >= selectedYear ? "Save & Continue" : "Next"}
            </span>
            <ArrowRight />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FillCopanyData